import { createFileRoute } from '@tanstack/react-router';

import { WorkspaceClientListScreen } from '@/features/clients/components/workspace/ClientListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/clients/')({
  beforeLoad: () => {
    requirePermission('client:read');
  },
  component: ClinicalMyClientsRoute,
  staticData: { crumb: 'Clients' },
});

function ClinicalMyClientsRoute() {
  return (
    <WorkspaceClientListScreen
      titleOverride="Clients"
      descriptionOverride="Clients in your caseload."
      surface="clinical"
    />
  );
}
